import { _ } from '@ngx-translate/core';
import { LdEventInvestigationResult } from '@app/main/leak-detection/enums/ld-event-investigation-result.enum';
import { LdEventRepairStatus } from '@app/main/leak-detection/enums/ld-event-repair-status.enum';
import { ldEventRepairStatusIcon } from '@app/main/leak-detection/configs/ld-event-status.config';

export const dialogEventResultBadgeLabel: Record<
  LdEventInvestigationResult,
  Partial<Record<LdEventRepairStatus, string>> & { base: string }
> = {
  [LdEventInvestigationResult.Leak]: {
    base: _(`@@shared-leak__label`),
    [LdEventRepairStatus.NotRepaired]: _(`@@fp-event-result-badge__leak-not-repaired`),
    [LdEventRepairStatus.RepairScheduled]: _(`@@fp-event-result-badge__leak-repair-scheduled`),
    [LdEventRepairStatus.Repaired]: _(`@@fp-event-result-badge__leak-repaired`),
  },
  [LdEventInvestigationResult.CustomerSideLeak]: {
    base: _(`@@shared-events-investigation-result__customer-side-leak`),
    [LdEventRepairStatus.NotRepaired]: _(`@@fp-event-result-badge__customer-side-leak-not-repaired`),
    [LdEventRepairStatus.RepairScheduled]: _(`@@fp-event-result-badge__customer-side-leak-repair-scheduled`),
    [LdEventRepairStatus.Repaired]: _(`@@fp-event-result-badge__customer-side-leak-repaired`),
  },
  [LdEventInvestigationResult.NoLeak]: {
    base: _(`@@shared-events-investigation-result__no-leak`),
  },
};

export function dialogEventResultLabel(
  result: LdEventInvestigationResult,
  repairStatus: LdEventRepairStatus | null | undefined
): string {
  const labels = dialogEventResultBadgeLabel[result];

  return (repairStatus && labels[repairStatus]) || labels.base;
}

export const dialogEventResultBadgeTheme: Record<LdEventRepairStatus, string> = {
  [LdEventRepairStatus.NotRepaired]: 'bg-(--p-red-50)',
  [LdEventRepairStatus.RepairScheduled]: 'bg-(--p-orange-100)',
  [LdEventRepairStatus.Repaired]: 'bg-(--p-green-100)',
};

export const DIALOG_EVENT_NEUTRAL_BADGE_THEME = 'bg-(--p-sky-100)';

export const DIALOG_EVENT_HIDDEN_BADGE_THEME = 'bg-(--p-other-gray-50) text-(--p-blue-600)';

export const dialogEventRepairBorderTheme: Record<LdEventRepairStatus, string> = {
  [LdEventRepairStatus.NotRepaired]: '!border-(--p-red-100)',
  [LdEventRepairStatus.RepairScheduled]: '!border-(--p-orange-300)',
  [LdEventRepairStatus.Repaired]: '!border-(--p-green-300)',
};

export const DIALOG_EVENT_NEUTRAL_BADGE_BORDER = '!border-(--p-sky-100)';

export const dialogEventRepairChipTheme: Record<LdEventRepairStatus, string> = {
  [LdEventRepairStatus.NotRepaired]: '!bg-(--p-red-50)',
  [LdEventRepairStatus.RepairScheduled]: '!bg-(--p-orange-100)',
  [LdEventRepairStatus.Repaired]: '!bg-(--p-green-100)',
};

export const dialogEventRepairOverlayIcon = ldEventRepairStatusIcon;
